import { jsx as _jsx } from "react/jsx-runtime";
import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.min.css";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import { BEOControllerProvider } from "./context/BeoContext";
import i18n from "./i18n";
import "./styles/tailwind.css";
//prime react theme should come after tailwind css
import { LoadingProvider } from "@context/BeoLoadingContext";
import "primereact/resources/themes/lara-light-amber/theme.css";
import "./styles/css/common/glow.css";
import React from "react";
// Create a QueryClient instance
// const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(PrimeReactProvider, { value: {
            hideOverlaysOnDocumentScrolling: true,
            autoZIndex: true,
            zIndex: {
                modal: 1100,
                overlay: 1000,
                menu: 1000,
                tooltip: 1100,
                toast: 1200,
            },
            unstyled: false
        }, children: _jsx(BEOControllerProvider, { children: _jsx(LoadingProvider, { children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(App, {}) }) }) }) }) }));
